import { FontFamilyByLanguageTheme } from '@kite-js/theme-types';
import families from './families';

const familiesByLanguage: FontFamilyByLanguageTheme[] = [
    {
        lang: '', // default
        families: [
            families.interState,
            families.inter,
            families.helveticaNeue,
            families.helvetica,
            families.arial,
            families.sansSerif,
        ],
    },
];

export default familiesByLanguage;
